import {useState} from 'react';
import {Tabs, Typography} from 'antd';
import {ComplyCubeAddressesTab} from './kycViewer/ComplyCubeAddressesTab';
import {ComplyCubeChecksTab} from './kycViewer/ComplyCubeChecksTab';
import {ComplyCubeClientModal} from './kycViewer/ComplyCubeClientModal';
import {ComplyCubeClientsTab} from './kycViewer/ComplyCubeClientsTab';
import {ComplyCubeDocumentsTab} from './kycViewer/ComplyCubeDocumentsTab';
import {ComplyCubeLivePhotosTab} from './kycViewer/ComplyCubeLivePhotosTab';
import styles from './kycDashboard.module.scss';

const {Title, Text} = Typography;
const {TabPane} = Tabs;

export const KycViewer = () => {
  const [modalClientId, setModalClientId] = useState(null);

  const openClientDetail = id => {
    if (id) setModalClientId(String(id));
  };

  return (
    <div className={styles.viewerRoot}>
      <div className={styles.sectionIntro}>
        <Title level={4}>KYC Data Lake</Title>
        <Text type="secondary">
          Browse KYC Data Lake clients, checks, documents, addresses, and live
          photos. Open a client row or click a client ID for full detail.
        </Text>
      </div>

      <Tabs defaultActiveKey="clients" className={styles.viewerInnerTabs}>
        <TabPane tab="Clients" key="clients">
          <ComplyCubeClientsTab openClientDetail={openClientDetail} />
        </TabPane>
        <TabPane tab="Checks" key="checks">
          <ComplyCubeChecksTab openClientDetail={openClientDetail} />
        </TabPane>
        <TabPane tab="Documents" key="documents">
          <ComplyCubeDocumentsTab openClientDetail={openClientDetail} />
        </TabPane>
        <TabPane tab="Addresses" key="addresses">
          <ComplyCubeAddressesTab openClientDetail={openClientDetail} />
        </TabPane>
        <TabPane tab="Live photos" key="livePhotos">
          <ComplyCubeLivePhotosTab openClientDetail={openClientDetail} />
        </TabPane>
      </Tabs>

      <ComplyCubeClientModal
        open={!!modalClientId}
        clientId={modalClientId}
        onClose={() => setModalClientId(null)}
        onNavigateClient={openClientDetail}
      />
    </div>
  );
};
